import React from 'react';
import Icon from '../../../components/AppIcon';

const LoadingOverlay = ({ isVisible, message = "Authenticating..." }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[200] flex items-center justify-center">
      <div className="bg-card rounded-2xl shadow-lg border border-border p-8 max-w-sm mx-4">
        <div className="flex flex-col items-center">
          <div className="relative w-16 h-16 mb-4">
            <div className="absolute inset-0 border-4 border-primary/20 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <Icon name="Lock" size={24} color="var(--color-primary)" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">
            {message}
          </h3>
          <p className="text-sm text-muted-foreground text-center">
            Please wait while we securely connect to your account
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;